export interface MarkdownHeading {
  id: string;
  level: number;
  text: string;
}

function slugify(value: string) {
  return value
    .toLowerCase()
    .replace(/[`*_~\[\](){}<>]/g, "")
    .replace(/[^\p{Letter}\p{Number}]+/gu, "-")
    .replace(/^-+|-+$/g, "") || "section";
}

export function headingId(scope: string, index: number, text: string) {
  return `${scope}-heading-${index}-${slugify(text)}`;
}

export function extractMarkdownHeadings(content: string, scope: string): MarkdownHeading[] {
  const headings: MarkdownHeading[] = [];
  let fenced = false;
  for (const line of content.split(/\r?\n/)) {
    if (/^\s*(```|~~~)/.test(line)) { fenced = !fenced; continue; }
    if (fenced) continue;
    const match = /^(#{1,3})\s+(.+?)\s*#*\s*$/.exec(line);
    if (!match) continue;
    const text = match[2].replace(/\[([^\]]+)]\([^)]*\)/g, "$1").replace(/[`*_~]/g, "").trim();
    if (!text) continue;
    headings.push({ id: headingId(scope, headings.length, text), level: match[1].length, text });
  }
  return headings;
}
